import { useMutation, useQueryClient } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withGlobalError } from '@/react-tools/react-query';

import { TypedPolicy } from '../types';

import { queryKeys } from './query-keys';
import { CreatePolicyPayload } from './types';

export function useCreatePolicyMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createPolicy,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.list() });
    },
    ...withGlobalError('Unable to create policy'),
  });
}

async function createPolicy(
  payload: CreatePolicyPayload
): Promise<TypedPolicy<unknown>> {
  try {
    const { data } = await axios.post<TypedPolicy<unknown>>(
      '/policies',
      payload
    );
    return data;
  } catch (error) {
    throw parseAxiosError(error, 'Unable to create policy');
  }
}
